import HeroImageSlider from './HeroImageSlider';

export default function HeroBackground() {
  return <HeroImageSlider />;
}
